import { HttpResponse } from 'msw';

import { DEVICE_TYPE } from '../constants';
import { getPortConfiguration } from '../helper';

type LegacyBody = { command?: string; access?: string };

export function handleStpLegacy(
  body: LegacyBody,
): ReturnType<typeof HttpResponse.json> {
  const command = body.command ?? '';
  const access = body.access ?? 'get';
  const portCfg = getPortConfiguration(DEVICE_TYPE);

  switch (command) {
    case 'get stp version':
      if (access === 'get') {
        return HttpResponse.json(
          { lan: 'rstp' as const, lanprio: 8 },
          { status: 200 },
        );
      }
      break;
    case 'set stp version':
      if (access === 'set') {
        return HttpResponse.json({ ok: true }, { status: 200 });
      }
      break;
    case 'port state':
      if (access === 'get') {
        const states = ['forwarding', 'blocking', 'learning', 'discarding'];
        const roles = ['root', 'designated', 'alternate', 'backup'];
        const list = portCfg.names.map((name, i) => ({
          port: name,
          state: states[i % states.length],
          role: roles[i % roles.length],
        }));
        return HttpResponse.json(list, { status: 200 });
      }
      break;
    case 'rootbridge':
      if (access === 'get') {
        return HttpResponse.json(
          { rootbridge: '8000.00:11:22:33:44:55' },
          { status: 200 },
        );
      }
      break;
    default:
      break;
  }

  return HttpResponse.json(
    { error: 'not implemented', msg: `Mock missing for stp:${command}` },
    { status: 400 },
  );
}
